module.exports = __webpack_public_path__ + "img/DefiStakingPlatform_logo_transparent_very-small-v3.8817bd7e.png";